<template>
  <div class="wrap-border article-wrap">
    <div class="article-title">
      {{
        formNav != 10 ? details.title : "修复名单公示(" + $route.params.id + ")"
      }}
    </div>
    <div class="flex flex-row-center article-source" v-if="formNav != 10">
      <p>来源：{{ details.source }}</p>
      <p>日期：{{ details.publishtime }}</p>
    </div>
    <div class="article-content ql-container ql-snow">
      <el-table
        v-if="formNav == 10"
        :data="details"
        style="width: 100%; margin-top: 50px"
      >
        <el-table-column prop="name" label="主体名称"> </el-table-column>
        <el-table-column prop="number" label="统一社会信用代码/身份证号">
        </el-table-column>
        <el-table-column prop="docNumber" label="决书文号"> </el-table-column>
        <el-table-column prop="punishAgency" label="处罚机关">
        </el-table-column>
      </el-table>
      <div v-else class="ql-editor" v-html="details.content"></div>
      <div v-for="item in fileList" class="fileclass" :key="item.id">
        <el-link
          @click="downLoad(item.name, item.fileId)"
          target="_blank"
          type="danger"
        >
          {{ item.name }}
        </el-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  articleTopicsDetail,
  downLoadFile,
  getPunishesDetail,
  getDynamicDetail,
  getNoticesDetail,
  getRisksDetail,
  getSpecialsDetail,
  getResearchesDetail,
  getPoliciesDetail,
  getTypicalDetail,
  getIndustriesDetail,
  repairByDate,
  getLetterEasyDetail,
  getCreditRealTimeDetail
} from "@/api";
import {
  getRewardPunishesHot,
  articleTopicsHot,
  getNoticesHot,
  getDynamicsHot,
  getRisksHot,
  getSpecialsHot,
  getResearchesHot,
  getPoliciesHot,
  getTypicalHot,
  getIndustriesHot,
  getLetterEasyHot,
} from "@/api";
import BASE_URL from "@/api/base.js";

export default {
  components: {},
  data() {
    return {
      details: {},
      fileList: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    downLoad(name, url) {
      let data = { fileName: name, url: url };
      downLoadFile(data).then((res) => {
        if (!res) return;
        //创建 blob 对象
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        //创建一个唯一的 URL
        const url = URL.createObjectURL(blob);
        //下载文件
        //创建一个a标签
        const a = document.createElement("a");
        //将下载地址赋值给herf属性
        a.href = url;
        //设置下载文件的名字
        a.download = name;
        a.click();
        //读文件  创建 FileReader 对象
        const reader = new FileReader();
        //文件内容转为 String
        reader.readAsText(blob);
        //当读取操作成功完成时调用
        reader.onload = () => {
          this.result = reader.result;
        };
      });
    },

    getDetail(id) {
      this.requestMethod({ id }).then((res) => {
        if (+this.formNav === 10) {
          console.log(res);
          this.$set(this, "details", res || []);
        } else {
          if (Object.keys(res).length) {
            this.$set(
              this,
              "details",
              Object.assign({}, res, {
                content: res.content.replace(
                  /<img src=\"/g,
                  `<img style="width: 100%;" src=\"${BASE_URL}`
                ),
              })
            );
            this.fileList = JSON.parse(res.matterfile);
          }
        }
      });
    },
    getHotList() {
      this.hotRequestMethod().then((res) => {
        this.$emit("layoutInit", {
          recommend: res,
          nav: {
            c_name: this.formNav,
          },
        });
      });
    },
  },
  computed: {
    formNav({ $route }) {
      const {
        params: { from },
      } = $route;
      return from;
    },
    requestMethod() {
      const {
        params: { from },
      } = this.$route;
      // 1信用动态，2行业信用，3诚信宣传，4政策法规，5信用研究，6专项治理,7风险提示,8联合奖惩,9通知公告
      //22/3/26增加 10 信用修复 看接口怎么对接

      switch (+from) {
        case 0:
          return articleTopicsDetail;
        case 1:
          return getDynamicDetail;
        case 2:
          return getIndustriesDetail;
        case 3:
          return getTypicalDetail;
        case 4:
          return getPoliciesDetail;
        case 5:
          return getResearchesDetail;
        case 6:
          return getSpecialsDetail;
        case 7:
          return getRisksDetail;
        case 8:
          return getPunishesDetail;
        case 9:
          return getNoticesDetail;
        case 10:
          return repairByDate;
        case 11:
          return getLetterEasyDetail;
        case 12:
          return getCreditRealTimeDetail;
        default:
          break;
      }
    },
    hotRequestMethod() {
      const {
        params: { from },
      } = this.$route;
      // 1信用动态，2行业信用，3诚信宣传，4政策法规，5信用研究，6专项治理,7风险提示,8联合奖惩,9通知公告
      //22/3/26增加 10 信用修复 看接口怎么对接
      switch (+from) {
        case 0:
          return articleTopicsHot;
        case 1:
          return getDynamicsHot;
        case 2:
          return getIndustriesHot;
        case 3:
          return getTypicalHot;
        case 4:
          return getPoliciesHot;
        case 5:
          return getResearchesHot;
        case 6:
          return getSpecialsHot;
        case 7:
          return getRisksHot;
        case 8:
          return getRewardPunishesHot;
        case 9:
          return getNoticesHot;
        case 10:
          return "";
        case 11:
          return getLetterEasyHot;
        default:
          break;
      }
    },
  },
  watch: {
    $route: {
      handler(v) {
        const {
          params: { id, from },
        } = v;
        this.$emit("article.tab.name", from);
        this.getDetail(id);
        this.getHotList();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style>
@import "./quill/quill.core.css";
@import "./quill/quill.snow.css";
@import "./quill/quill.bubble.scss";
.ql-container.ql-snow {
  border: none;
}
</style>
<style lang="scss">
.article-wrap {
  width: 100%;
  padding: 35px 54px 90px;
  background: #fff;
  word-wrap: break-word;
  & > .article-title {
    font-size: 18px;
    font-weight: 700;
    padding: 0 70px;
    text-align: center;
  }
  & > .article-source {
    margin: 12px 0 25px;
    & > p {
      font-size: 13px;
      margin-left: 22px;
      margin-right: 22px;
    }
  }
  .fileclass {
    margin-top: 10px;
  }
}
</style>
